import React from 'react';
import { Row, Col } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiCircleSlice1 } from '@mdi/js';

import './Avatar.css';

const Avatar = ({ src, width, className, ...rest }) => {
    return (
        <div
            className={`Avatar ${className ?? ''}`}
            style={{width: `${width || 80}px`, height: `${width || 80}px`}}
            { ...rest }
        >
            <img src={src} className="img" alt="..." />
        </div>
    );
}

export default Avatar;
